export default __webpack_public_path__ + "static/media/english-to-korean-screenshot-06.892063e1.png";